
export const registeredFBP = (data) => {
    // return process.env.REACT_APP_NODE_ENV === 'production'
    //     ? import('react-facebook-pixel')
    //         .then(ReactPixel => {
    //             ReactPixel.default.track('Register User', data)
    //         })
    //     : ''
}
